export default __webpack_public_path__ + "static/campsites-overview-e42d827470ff22b3af2edc6b976a4f87.jpg";